var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { DateFormat, DiscountType } from '@logz-pkg/enums';
import { Expose } from 'class-transformer';
import moment from 'moment';
export class CouponModel {
    billingCycle;
    description;
    discount = 0;
    discountCycles;
    discountType;
    expirationDate;
    yearlyLimitPrice;
    get formattedExpirationDate() {
        return moment(this.expirationDate * 1000)
            .utc()
            .format(DateFormat.DashedDateTimeFull);
    }
    get isPercentageDiscountType() {
        return this.discountType === DiscountType.Percentage;
    }
    get discountText() {
        return this.isPercentageDiscountType ? `${this.discount}%` : `$${this.discount}`;
    }
}
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], CouponModel.prototype, "formattedExpirationDate", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], CouponModel.prototype, "isPercentageDiscountType", null);
__decorate([
    Expose({ toClassOnly: true }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], CouponModel.prototype, "discountText", null);
//# sourceMappingURL=coupons.js.map